import { useLanguage } from "../stores/LanguageStore";
import { useProfileStore } from "../stores/UserStore";

export function parseDateTime(datetimeString, toIso = false) {
  let result = new Date(
    parseInt(datetimeString.substring(6, 10)), // year
    parseInt(datetimeString.substring(3, 5)) - 1, // month (0-indexed)
    parseInt(datetimeString.substring(0, 2)), // day
    parseInt(datetimeString.substring(11, 13)), // hours
    parseInt(datetimeString.substring(14, 16)) // minutes
  );

  return toIso ? result.toISOString() : result;
}

function differenceMinute(date) {
  const currentTime = new Date();
  const inputTime = new Date(date);

  // Calculate the time difference in milliseconds
  const timeDifferenceMinute =
    (currentTime.getTime() - inputTime.getTime()) / 1000 / 60;

  // Check if the time difference is less than 5 minutes (300,000 milliseconds)
  return Math.ceil(timeDifferenceMinute);
}

function differenceMinuteFuture(date, currentTime = new Date()) {
  const inputTime = new Date(date);

  // Calculate the time difference in milliseconds
  const timeDifferenceMinute =
    (inputTime.getTime() - currentTime.getTime()) / 1000 / 60;

  // Check if the time difference is less than 5 minutes (300,000 milliseconds)
  return Math.ceil(timeDifferenceMinute);
}

export function parseDate(date, disableHours = true) {
  const lang = useLanguage.getState().language;
  const today = new Date();
  const value = new Date(date);

  // let offset = new Date().getTimezoneOffset() / 60;
  const diffMinutes = differenceMinute(date);

  const hours = Math.floor(diffMinutes / 60);
  const remainingMinutes = diffMinutes % 60;

  if (diffMinutes < 0) {
    return parseDateFuture(date, new Date(), disableHours);
  }

  if (hours > 0 && hours < 12) {
    if (lang.id === "FRA") return ` Il y a ${hours}h ${remainingMinutes}mn`;
    return ` ${hours}h ${remainingMinutes}mn ago`;
  }
  if (hours < 1 && diffMinutes < 1) {
    if (lang.id === "FRA") return ` À l'instant`;
    return ` Just now`;
  }
  if (hours === 0) {
    if (lang.id === "FRA") return ` Il y a ${diffMinutes}mn`;
    return `${diffMinutes}mn ago`;
  }
  if (today.toDateString() === value.toDateString()) {
    if (lang.id === "FRA")
      return ` Aujourd'hui, ${value.getHours().toString().startsWith("0") ? "" : "0"}${value.getHours()}:${value.getMinutes().toString().startsWith("0") ? "" : "0"}${value.getMinutes()}`;
    return ` Today, ${value.getHours()}:${value.getMinutes()}`;
  }

  let v;
  if (disableHours) {
    v = value.toLocaleString(lang.id === "FRA" ? "fr-FR" : "en-EN", {
      weekday: "long",
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }
  else {
    v = value.toLocaleString(lang.id === "FRA" ? "fr-FR" : "en-EN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    });
  }

  function getPre() {
    if (isYesterday(value)) {
      if (lang.id === "FRA") return `Hier, `;
      return `Yesterday, `;
    }
    return "";
  }

  return `${disableHours ? "" : getPre()} ${v.charAt(0).toUpperCase() + v.slice(1)}`;
}

function isTomorrow(date) {
  const now = new Date();

  // Create a Date object for tomorrow
  const tomorrow = new Date();
  tomorrow.setDate(now.getDate() + 1);

  // Compare year, month, and date parts
  return (
    date.getFullYear() === tomorrow.getFullYear() &&
    date.getMonth() === tomorrow.getMonth() &&
    date.getDate() === tomorrow.getDate()
  );
}

function isYesterday(date) {
  const now = new Date();

  // Create a Date object for yesterday
  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  // Compare year, month, and date parts
  return (
    date.getFullYear() === yesterday.getFullYear() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getDate() === yesterday.getDate()
  );
}

export function parseDateFuture(date, today = new Date(), disableHours = true) {
  const lang = useLanguage.getState().language;
  const value = new Date(date);

  function getPre() {
    if (isTomorrow(value)) {
      if (lang.id === "FRA") return `Demain, `;
      return `Tomorrow, `;
    }
    return "";
  }

  let v;
  if (disableHours) {
    v = value.toLocaleString(lang.id === "FRA" ? "fr-FR" : "en-EN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  }
  else {
    v = value.toLocaleString(lang.id === "FRA" ? "fr-FR" : "en-EN", {
      weekday: "long",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    });
  }

  let vString = v.charAt(0).toUpperCase() + v.slice(1)

  const diffMinutes = differenceMinuteFuture(date, today);

  const hours = Math.floor(diffMinutes / 60);
  const remainingMinutes = diffMinutes % 60;

  if (hours === 0) {
    if (lang.id === "FRA") return ` Dans ${remainingMinutes}mn (${vString})`;
    return ` in ${remainingMinutes}mn (${vString})`;
  }
  if (hours > 0 && hours < 12) {
    if (lang.id === "FRA") return ` Dans ${hours}h ${remainingMinutes}mn (${vString})`;
    return ` in ${hours}h ${remainingMinutes}mn (${vString})`;
  }
  if (today.toDateString() === value.toDateString()) {
    if (lang.id === "FRA")
      return ` Aujourd'hui, ${value.getHours()}:${value.getMinutes()} (${vString})`;
    return `Today, ${value.getHours()}:${value.getMinutes()} (${vString})`;
  }

  return `${getPre()} ${vString}`;
}

export function getDuration(date, today) {
  // Assuming useLanguage and differenceMinuteFuture are defined elsewhere
  const lang = useLanguage.getState().language;

  // Calculate total difference in minutes
  const diffMinutes = differenceMinuteFuture(date, today);

  if (diffMinutes <= 0) {
    return "0mn";
  }

  // Calculate days, hours, and minutes from total minutes
  const days = Math.floor(diffMinutes / 1440); // 1440 minutes in a day
  const remainingHours = Math.floor((diffMinutes % 1440) / 60);
  const remainingMinutes = diffMinutes % 60;

  // Build the duration string
  let durationParts = [];
  if (days > 0) {
    // Using 'j' for 'jour' (day) as per the 'h' and 'mn' convention
    durationParts.push(`${days}j`);
  }
  if (remainingHours > 0) {
    durationParts.push(`${remainingHours}h`);
  }
  if (remainingMinutes > 0) {
    durationParts.push(`${remainingMinutes}mn`);
  }

  // If the duration is less than 1 minute, show "0mn" or "<1mn"
  if (durationParts.length === 0) {
    return "<1mn";
  }

  return durationParts.join(' ');
}

export function incrementHour(timeString, incrementBy) {
  if (!timeString) {
    return timeString;
  }
  // Parse the original time string
  var parts = timeString.split(":");
  var hours = parseInt(parts[0], 10);
  var minutes = parseInt(parts[1], 10);
  var seconds = parseInt(parts[2], 10) || 0;

  // Increment the hours by the specified amount
  hours += incrementBy;

  if (hours < 0) {
    hours += 24;
  }

  // Ensure that hours remain in the 24-hour format (0-23)
  hours = hours % 24;

  // Format the new time back into the string format
  var newTimeString =
    (hours < 10 ? "0" : "") +
    hours +
    ":" +
    (minutes < 10 ? "0" : "") +
    minutes +
    ":" +
    (seconds < 10 ? "0" : "") +
    seconds;

  return newTimeString;
}

export function getRelativeDate(dateString) {
  const lang = useLanguage.getState().language;
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (date.toDateString() === today.toDateString()) {
    return "Aujourd'hui";
  } else if (date.toDateString() === yesterday.toDateString()) {
    return "Hier";
  } else {
    return date.toLocaleString(lang.id === "FRA" ? `fr-FR` : "en-EN", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  }
}

export function getWeekStartAndEnd(date, disableWeekend) {
  // Create copies of the date to avoid mutating the original
  const weekStart = new Date(date);
  const weekEnd = new Date(date);

  // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
  const dayOfWeek = weekStart.getDay();

  // Calculate how many days to subtract to get to Monday
  const daysToStart = (dayOfWeek === 0) ? -6 : -1 * (dayOfWeek - 1);
  weekStart.setDate(weekStart.getDate() + daysToStart);

  // Calculate how many days to add to get to Sunday
  const daysToEnd = disableWeekend ? 5 - dayOfWeek : 7 - dayOfWeek; // Move forward to Sunday or Friday
  weekEnd.setDate(weekEnd.getDate() + daysToEnd);

  return {
    weekStart,
    weekEnd
  };
}

export function getLastWeekStartAndEnd(date, disableWeekend) {
  // Clone the input date and shift it back by 7 days to land in last week
  const lastWeekDate = new Date(date);
  lastWeekDate.setDate(lastWeekDate.getDate() - 7);

  const weekStart = new Date(lastWeekDate);
  const weekEnd = new Date(lastWeekDate);

  // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const dayOfWeek = weekStart.getDay();

  // Move to Monday of that week
  const daysToStart = (dayOfWeek === 0) ? -6 : -1 * (dayOfWeek - 1);
  weekStart.setDate(weekStart.getDate() + daysToStart);

  // Move to Friday or Sunday depending on disableWeekend
  const daysToEnd = disableWeekend ? 5 - 1 : 7 - 1; // Friday or Sunday (relative to Monday)
  weekEnd.setDate(weekStart.getDate() + daysToEnd);

  return {
    weekStart,
    weekEnd
  };
}

export function getYearStartAndEnd(date) {
  const yearStart = new Date(date.getFullYear(), 0, 1);    // Jan 1
  const yearEnd = new Date(date.getFullYear(), 11, 31);    // Dec 31

  return {
    yearStart,
    yearEnd
  };
}

export function getMonthStartAndEnd(date) {
  // Create a new date object to avoid mutating the original
  const monthStart = new Date(date.getFullYear(), date.getMonth(), 1);
  const monthEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0); // Last day of the month

  return {
    monthStart,
    monthEnd
  };
}

export function getLastXMonthsRange(date, months) {
  const end = new Date(date.getFullYear(), date.getMonth() + 1, 0); // End of current month
  const start = new Date(date.getFullYear(), date.getMonth() - (months - 1), 1); // Start of X months ago

  return { start, end };
}

export function getLastXDaysStartAndEnd(x) {
  const today = new Date();

  const startDate = new Date(today);
  startDate.setDate(today.getDate() - x); // Subtract 29 days to include today

  return { start_date: startDate.toISOString(), end_date: today.toISOString() };
}

export function getLast60DaysStartAndEnd() {
  const today = new Date();

  const startDate = new Date(today);
  startDate.setDate(today.getDate() - 59); // Subtract 59 days to include today

  return { start_date: startDate.toISOString(), end_date: today.toISOString() };
}

export const defaultDateRange = getLast60DaysStartAndEnd()
//.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

export function getQuarter(dateStr) {
  const month = new Date(dateStr).getMonth() + 1; // getMonth is zero-based
  return Math.ceil(month / 3); // Divide the month by 3 and round up
}

export function getTimezoneOffset(tz) {
  const timezone = tz || useProfileStore.getState().profile?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone

  if (timezone) {
    let date = new Date()
    const utcDate = new Date(date.toLocaleString("en-US", { timeZone: "UTC" }));
    const tzDate = new Date(
      date.toLocaleString("en-US", { timeZone: timezone })
    );
    return (utcDate - tzDate) / 60000 / 60;
  }
  else {
    return new Date().getTimezoneOffset() / 60
  }
}

export function addHoursToDate(dateString, hours) {
  const date = new Date(dateString); // Convert the string to a Date object
  date.setHours(date.getHours() + hours); // Add or subtract hours
  return date.toISOString(); // Return the updated Date object
}

export function daysUntil(targetDate) {
  const lang = useLanguage.getState().language;
  const today = new Date(); // Get today's date
  const target = new Date(targetDate); // Convert the input into a Date object

  // Calculate the difference in milliseconds
  const diffInMs = target - today;

  // Convert milliseconds to days (1 day = 24 * 60 * 60 * 1000 ms)
  const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

  return diffInDays > 0
    ? `${lang.home.remaining_days} ${diffInDays} ${lang.home.days} `
    : `Période d'essai terminé`;
}

export function formatMinDate(date) {
  const d = new Date(date);
  const now = new Date();

  const isToday =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate();

  if (isToday) {
    // Format hours:minutes -> 08:42
    return d.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } else {
    // Format as DD/MM/YY -> 21/10/25
    return d
      .toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
      })
      .replace(/\./g, '/'); // in case locale adds dots
  }
}